export enum PopoverBorder {
  default = 'default',
  primary = 'primary',
  secondary = 'secondary',
  tertiary = 'tertiary',
  quaternary = 'quaternary'
}

export enum PopoverBackground {
  default = 'default',
  contrast = 'contrast',
  educational = 'educational'
}

export enum PopoverPointerPosition {
  center = 'center',
  centerPositive = 'center-positive',
  centerNegative = 'center-negative'
}
